export const SESSION_STORAGE_KEY = "dolfin_session";
